export { EquipmentSuggestionsResults } from './equipment-suggestions-results';
